import { useRef, useCallback } from "react";

const SWIPE_MIN = 56;

/**
 * Horizontal swipe → action id.
 * @param {{ left?: string, right?: string }} map
 */
export function useSwipeAction(map = {}, { disabled = false } = {}) {
  const startRef = useRef(null);

  const onTouchStart = useCallback(
    (e) => {
      if (disabled) return;
      const t = e.changedTouches?.[0] || e.touches?.[0];
      if (!t) return;
      startRef.current = { x: t.clientX, y: t.clientY };
    },
    [disabled]
  );

  const onTouchEnd = useCallback(
    (e) => {
      if (disabled || !startRef.current) return;
      const t = e.changedTouches?.[0];
      if (!t) return;
      const dx = t.clientX - startRef.current.x;
      const dy = t.clientY - startRef.current.y;
      startRef.current = null;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      const action = dx < 0 ? map.left : map.right;
      if (action) return action;
      return null;
    },
    [disabled, map]
  );

  const bind = {
    onTouchStart,
    onTouchEnd: (e) => {
      const action = onTouchEnd(e);
      if (action && map.onAction) map.onAction(action);
    },
  };

  return bind;
}
